<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00054" title="[65]"><a id="Page_65"></a></span></p>
<h2 id="FROM_BAD_TO_WORSE">FROM BAD TO WORSE.</h2>
</div>
<div class="blockquot">
<p class="calibre3">THE ASTOR HOUSE MESS STILL HOLDS TOGETHER, ALTHOUGH DEPLETED—ALL
MORE OR LESS DISEASED—AS THE WEATHER GETS
WARMER THE DEATH RATE INCREASES—DYING OFF LIKE SHEEP—THE
END IS NOT YET.</p>
</div>
<p class="calibre3">June 8.—More new prisoners. There are now over 23,000 confined
here, and the death rate 100 to 130 per day, and I believe
more than that. Rations worse.</p>
<p class="calibre3">June 9.—It is said that a grand break will occur soon, and nearly
the whole prison engaged in the plot. Spies inform the rebels of
our intentions. Rains yet.</p>
<p class="calibre3">June 10.—The whole camp in a blaze of excitement. Plans for
the outbreak known to Capt. Wirtz. Some traitor unfolded the
plans to him. Thirty or forty pieces of artillery pointed at us from
the outside, and stockade covered with guards who shoot right and
left. Thirty or forty outsiders sent inside, and they tell us how the
affair was found out. A number of the ringleaders are undergoing
punishment. Hendryx has made his escape, and not been heard of
since yesterday. It is said he went away in full Confederate dress,
armed, and furnished with a guide to conduct him. Dr. Lewis
died to-day. Jack Walker told us about his death. Capt. Wirtz
has posted up on the inside a notice for us to read. The following
is the notice:</p>
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00055" title="[66]"><a id="Page_66"></a></span></p>
<div class="blockquotx">
<p class="center">“NOTICE.</p>
<p class="calibre3">Not wishing to shed the blood of hundreds not connected with
those who concocted a plan to force the stockade, and make in this
way their escape. I hereby warn the leaders and those who formed
themselves into a band to carry out this, that I am in possession of
all the facts, and have made my arrangements accordingly, so to
frustrate it. No choice would be left me but to open with grape
and cannister on the stockade, and what effect this would have in
this densely crowded place need not be told. Signed,</p>
<p class="right"><span class="smcap">H. Wirtz</span>.”</p>
<p class="calibre3">June 10, 1864.</p>
</div>
<p class="calibre3">June 11.—And so has ended a really colossal attempt at escape.
George Hendryx was one of the originators of the plan. He took
advantage of the excitement consequent upon its discovery and
made good his escape, and I hope will succeed in getting to our
lines. It is the same old situation here only worse, and getting
worse all the time. I am not very good at description, and find
myself at fault in writing down the horrible condition we are in.</p>
<p class="calibre3">June 12.—Rained every day so far this month. A portion of the
camp is a mud hole, and the men are obliged to lay down in it.
Fort Pillow prisoners tell some hard stories against the Confederacy
at the treatment they received after their capture. They came
here nearly <em>starved to death</em>, and a good many were wounded after
their surrender. They are mostly Tennesseeans, and a “right smart
sorry set.” Battese has taken quite a fatherly interest in me. Keeps
right on at the head of the washing and hair cutting business, paying
no attention to anything outside of his work. Says: “We get
out all right!”</p>
<p class="calibre3">June 13.—It is now as hot and sultry as it was ever my lot to
witness. The cloudy weather and recent rains make everything
damp and sticky. We don’t any of us sweat though, particularly,
as we are pretty well dried up. Laying on the ground so much has
made sores on nearly every one here, and in many cases gangrene
sets in and they are very bad off. Have many sores on my body,
but am careful to keep away the poison. To-day saw a man with a
bullet hole in his head over an inch deep, and you could look down
in it and see maggots squirming around at the bottom. Such things
are terrible, but of common occurrence. Andersonville seems to be
head-quarters for all the little pests that ever originated—flies by
the thousand millions. I have got into one bad scrape, and the one<span class="x-ebookmaker-pageno" id="pgepubid00056" title="[67]"><a id="Page_67"></a></span>
thing now is to get out of it. Can do nothing but take as good care
of myself as possible, which I do. Battese works all the time at
something. Has scrubbed his hands sore, using sand for soap.</p>
<p class="calibre3">June 14.—Mike Hoare stalks around, cheerful, black and hungry.
We have long talks about our school days when little boys together.
Mike is a mason by trade, and was solicited to go out and work for
the rebels. Told them he would work on nothing but vaults to
bury them in. Is a loyal soldier and had rather die here than help
them, as, indeed, would a majority of the prisoners. To tell the
truth, we are so near death and see so much of it, that it is not
dreaded as much as a person would suppose. We stay here day
after day, week after week, and month after month, seemingly forgotten
by all our friends at the North, and then our sufferings are
such that death is a relief in the view of a great many, and not
dreaded to any extent. By four o’clock each day the row of dead
at the gate would scare the life out of me before coming here, while
now it is nothing at all, but the same thing over and over.</p>
<p class="calibre3">June 15.—I am sick; just able to drag around. My teeth are
loose, mouth sore, with gums grown down in some places lower
than the teeth and bloody, legs swollen up with dropsy and on the
road to the trenches. Where there is so much to write about, I can
hardly write anything. It’s the same old story and must necessarily
be repetition. Raiders now do just as they please, kill, plunder
and steal in broad daylight, with no one to molest them. Have
been trying to organize a police force, but cannot do it. Raiders
are the stronger party. Ground covered with maggots. Lice by
the fourteen hundred thousand million infest Andersonville. A
favorite game among the boys is to play at odd or even, by putting
their hand inside some part of their clothing, pull out what they
can conveniently get hold of and say “odd or even?” and then
count up to see who beats. Think this is an original game here,
never saw it at the North. Some of the men claim to have pet lice
which they have trained. Am gradually growing worse. Nothing
but the good care I have taken of myself has saved me thus far. I
hope to last some time yet, and in the meantime relief may come.
My diary about written through. It may end about the same time
I do, which would be a fit ending.</p>
<p class="calibre3">June 16.—Old prisoners (some of them) will not credit the fact
that there is plenty to eat at the North. They think because we are
starved here, that it is so all over. They are crazy (as you may say)<span class="x-ebookmaker-pageno" id="pgepubid00057" title="[68]"><a id="Page_68"></a></span>
on the subject of food, and no wonder. In our dreams we see and
eat bountiful repasts, and awake to the other extreme. Never
could get a chance to talk with Capt. Wirtz, as he comes inside no
more. Probably just as well. Is a thoroughly bad man, without
an atom of humanity about him. He will get killed, should we
ever be released, as there are a great many here who would consider
it a christian duty to rid the earth of his presence. Disease is
taking right hold of me now. Battese is an angel; takes better
care of me than of himself. Although not in our mess or tent, he
is nearly all the time with us. It is wonderful the powers of endurance
he has. I have always been blessed with friends, and friends,
too, of the right sort. Had quite a talk with Dorr Blakeman, a
Jackson, Mich., boy. Was not much acquainted with him at home
but knew his people. Is a thoroughly good fellow, and a sensible
one. It is a relief to see any one who does not lose his head.</p>
<p class="calibre3">June 17.—Must nurse my writing material. A New York <cite>Herald</cite>
in camp, which says an exchange will commence the 7th of July.
Gen. Winder is on a visit to Andersonville. Is quite an aged man,
and white haired. Very warm and almost suffocating. Seems as
if the sun was right after us and belonged to the Confederacy.
Chas. Humphrey, of Massachusetts, who has been in our hundred
for months, has gone crazy; wanders about entirely naked, and not
even a cap on his head. Many of the prisoners are crazy, and I
only speak of those in our immediate proximity. Am in good spirits,
notwithstanding my afflictions. Have never really thought yet
that I was going to die in this place or in the Confederacy. Saw a
newcomer pounded to a jelly by the raiders. His cries for relief
were <em>awful</em>, but none came. Must a few villains live at the expense
of so many? God help us from these worse than rebels.</p>
<p class="calibre3">June 18.—Have now written two large books full; have another
at hand. New prisoners who come here have diaries which they
will sell for a piece of bread. No news to-day. Dying off as usual—more
in numbers each day as the summer advances. Rebels say
that they don’t begin to have hot weather down here until about
August. Well, it is plain to me that all will die. Old prisoners
have stood it as long as they can, and are dropping off fast, while
the new ones go anyhow. Some one stole my cap during the night.
A dead neighbor furnished me with another, however. Fast as the
men die they are stripped of their clothing so that those alive can
be covered. Pretty hard, but the best we can do. Rebels are anxious<span class="x-ebookmaker-pageno" id="pgepubid00058" title="[69]"><a id="Page_69"></a></span>
to get hold of Yankee buttons. “Buttons with hens on,” they
enquire for. An insult to the American Eagle—but they don’t
know any better.</p>
<p class="calibre3">June 19.—A young fellow named Conely tramps around the prison
with ball and chain on. His crime was trying to get away. I
say he tramps around, he tramps away from the gate with it on at
nine in the morning, and as soon as out of sight of the rebels he
takes it off, and only puts it on at nine o’clock the next morning to
report at the gate duly ironed off. They think, of course, that he
wears it all the time. Jimmy Devers looks and is in a very bad
way. Too bad if the poor fellow should die now, after being a
prisoner almost a year. Talks a great deal about his younger brother
in Jackson, named Willie. Says if he should die to be sure
and tell Willie not to drink, which has been one of Jimmy’s failings,
and he sees now what a foolish habit it is. Michael Hoare stands
it well. When a man is shot now it is called being “parolled.”</p>
<p class="calibre3">June 20.—All the mess slowly but none the less surely succumbing
to the diseases incident here. We are not what you may call
hungry. I have actually felt the pangs of hunger more when I was
a boy going home from school to dinner. But we are sick and faint
and all broken down, feverish &amp;c. It is starvation and disease and
exposure that is doing it. Our stomachs have been so abused by
the stuff called bread and soups, that they are diseased. The bread
is coarse and musty. Believe that half in camp would die now if
given rich food to eat.</p>
<p class="calibre3">June 21.—I am a fair writer, and am besieged by men to write
letters to the rebel officers praying for release, and I do it, knowing
it will do no good, but to please the sufferers. Some of these letters
are directed to Capt. Wirtz, some to Gen. Winder, Jeff Davis
and other officers. As dictated by them some would bring tears
from a stone. One goes on to say he has been a prisoner of war over
a year, has a wife and three children destitute, how much he thinks
of them, is dying with disease, etc., etc. All kinds of stories are
narrated, and handed to the first rebel who comes within reach.
Of course they are never heard from. It’s pitiful to see the poor
wretches who think their letters will get them out, watch the gate
from day to day, and always disappointed. Some one has much to
answer for.</p>
<p class="calibre3">June 22.—The washing business progresses and is prosperous.
One great trouble is, it is run too loose and we often get no pay.
Battese, while a good worker, is no business man, and will do anybody’s<span class="x-ebookmaker-pageno" id="pgepubid00059" title="[70]"><a id="Page_70"></a></span>
washing on promises, which don’t amount to much. Am not
able to do much myself, principally hanging out the clothes; that
is, laying the shirt on one of the tent poles and then watching it till
dry. All day yesterday I lay under the “coverlid” in the shade,
hanging on to a string which was tied to the washing. If I saw a
suspicious looking chap hanging around with his eyes on the
washed goods, then gave a quick jerk and in she comes out of
harm’s way. Battese has paid for three or four shirts lost in this
way, and one pair of pants. Pays in bread. A great many Irish
here, and as a class, they stand hardships well. Jimmy Devers
losing heart and thinks he will die. Capt. Wirtz has issued another
order, but don’t know what it is—to the effect that raiding and killing
must be stopped, I believe. Being unable to get around as I
used to, do not hear the particulars of what is going on, only in a
general way. New men coming in, and bodies carried out. Is
there no end but dying?</p>
<p class="calibre3">June 23.—My coverlid nobly does duty, protecting us from the
sun’s hot rays by day and the heavy dews at night. Have no doubt
but it has saved my life many times. Never have heard anything
from Hendryx since his escape. Either got away to our lines or
shot. Rebels recruiting among us for men to put in their ranks.
None will go—yes, I believe one Duffy has gone with them. Much
fighting. Men will fight as long as they can stand up. A father
fights his own son not ten rods from us. Hardly any are strong
enough to do much damage except the raiders, who get enough to
eat and are in better condition than the rest. Four or five letters
were delivered to their owners. Were from their homes. Remarkable,
as I believe this is the first mail since our first coming here.
Something wrong. Just shake in my boots—shoes, I mean, (plenty
of room) when I think what July and August will do for us. Does
not seem to me as if any can stand it. After all, it’s hard killing a
man. Can stand most anything.</p>
<p class="calibre3">June 24.—Almost July 1st, when Jimmy Devers will have been a
prisoner of war one year. Unless relief comes very soon he will
die. I have read in my earlier years about prisoners in the revolutionary
war, and other wars. It sounded noble and heroic to be a
prisoner of war, and accounts of their adventures were quite romantic;
but the romance has been knocked out of the prisoner of war
business, higher than a kite. It’s a fraud. All of the “Astor
House Mess” now afflicted with scurvy and dropsy more or less,
with the exception of Battese, and myself worst of any. Am fighting<span class="x-ebookmaker-pageno" id="pgepubid00060" title="[71]"><a id="Page_71"></a></span>
the disease, however, all the time, and the growth is but slight.
Take exercise every morning and evening, when it is almost impossible
for me to walk. Walk all over before the sun comes up,
drink of Battese’s medicine made of roots, keep clear of vermin,
talk and even laugh, and if I do die, it will not be through neglect.
Carpenter, the teamster who sold me the boots, is about gone, and
thank the Lord he has received his sixty cents from me, in rations.
Sorry for the poor fellow. Many who have all along stood it nobly
now begin to go under. Wm. B. Rowe, our tall mess-mate, is quite
bad off, still, he has an iron constitution and will last some time
yet.</p>
<p class="calibre3">June 25.—Another lead pencil wore down to less than an inch in
length, and must skirmish around for another one. New men
bring in writing material and pencils. To-day saw a New York
<cite>Herald</cite> of date June 11th, nothing in it about exchange, however.
That is all the news that particularly interests us, although accounts
of recent battles are favorable to the Union side. Our guards are
composed of the lowest element of the South—poor white trash.
Very ignorant, much more so than the negro. Some of them act as
if they never saw a gun before. The rebel adjutant does quite a
business selling vegetables to those of the prisoners who have money,
and has established a sutler stand not very far from our mess.
Hub Dakin, an old acquaintance, is a sort of clerk, and gets enough
to eat thereby. Hot! Hot! Raiders kill some one now every day.
No restraint in the least. Men who were no doubt respectable at
home, are now the worst villains in the world. One of them was
sneaking about our quarters during the night, and Sanders knocked
him about ten feet with a board. Some one of us must keep awake
all the time, and on the watch, fearing to loose what little we have.</p>
<p class="calibre3">June 26.—The same old story, only worse, worse. It seems all
the time it was as bad as could be, but is not. They die now like
sheep—fully a hundred each day. New prisoners come inside in
squads of hundreds, and in a few weeks are <em>all dead</em>. The change
is too great and sudden for them. Old prisoners stand it the best.
Found a Jackson, Michigan man, who says I am reported dead
there. Am not, however, and may appear to them yet. Jimmy
Devers is very bad with the scurvy and dropsy and will probably
die if relief does not come. Sergt. Rowe also is afflicted; in fact all
the mess except Battese. He does all the cooking now. He has
made me a cane to walk with, brings water from the well, and performs<span class="x-ebookmaker-pageno" id="pgepubid00061" title="[72]"><a id="Page_72"></a></span>
nearly all the manual labor for us. He is a jewel, but a
rough one.</p>
<p class="calibre3">June 27.—Raiders going on worse than ever before. A perfect
pandemonium. Something must be done, and that quickly. There
is danger enough from disease, without being killed by raiders.
Any moment fifty or a hundred of them are liable to pounce upon
our mess, knock right and left and take the very clothing off our
backs. No one is safe from them. It is hoped that the more peaceable
sort will rise in their might and put them down. Our misery
is certainly complete without this trouble added to it. We should
die in peace anyway. Battese has called his Indian friends all together,
and probably a hundred of us are banded together for self
protection. The animal predominates. All restraint is thrown off
and the very Old Harry is to pay. The farther advanced the summer,
the death rate increases, until they die off by scores. I walk
around to see friends of a few days ago and am told “dead.” Men
stand it nobly and are apparently ordinarily well, when all at once
they go. Like a horse, that will stand up until he drops dead.
Some of the most horrible sights that can possibly be, are common
every day occurrances. See men laying all around in the last
struggles.</p>
<p class="calibre3">June 28.—It seems to me as if three times as many as ever before
are now going off, still I am told that about one hundred and thirty
die per day. The reason it seems worse, is because no sick are
being taken out now, and they all die here instead of at the hospital.
Can see the dead wagon loaded up with twenty or thirty
bodies at a time, two lengths, just like four foot wood is loaded on
to a wagon at the North, and away they go to the grave yard on a
trot. Perhaps one or two will fall off and get run over. No attention
paid to that; they are picked up on the road back after more.
Was ever before in this world anything so terrible happening?
Many entirely naked.</p>
<p class="calibre3">June 29.—Capt. Wirtz sent inside a guard of fifteen or twenty to
arrest and take out quite a number of prisoners. They had the
names and would go right to their quarters and take them. Some
tell-tale traitor has been informing on them, for attempting to
escape or something. Wirtz punishes very hard now; so much
worse than a few months ago. Has numerous instruments of torture
just outside the gate. Sores afflict us now, and the Lord only
knows what next. Scurvy and scurvy sores, dropsy, not the least
thing to eat that can be called fit for any one, much less a sick<span class="x-ebookmaker-pageno" id="pgepubid00062" title="[73]"><a id="Page_73"></a></span>
man, water that to drink is poison, no shelter, and surrounded by
raiders liable to cut our throats any time. Surely, this is a go.
Have been reading over the diary, and find nothing but grumbling
and growlings. Had best enumerate some of the better things of
this life. I am able to walk around the prison, although quite
lame. Have black pepper to put in our soups. Am as clean perhaps
as any here, with good friends to talk cheerful to. Then, too,
the raiders will let us alone until about the last, for some of them
will get killed when they attack the “Astor House Mess.” Am
probably as well off as any here who are not raiders, and I should
be thankful, and am thankful. Will live probably two or three
months yet. “If t’weren’t for hope the heart would break,” and I
am hopeful yet. A Pennsylvanian of German descent, named Van
Tassel, and who has “sorter identified himself with us” for two or
three months, died a few moments ago. The worst cases of the
sick are again taken to the hospital—that is, a few of the worst
cases. Many prefer to die among their friends inside. Henry
Clayton also died to-day. Was at one time in charge of our Division,
and an old prisoner. Mike Hoare still hangs on nobly, as also
do many other of my friends and acquaintances. Dorr Blakeman
stands it unusually well. Have had no meat now for ten days;
nothing but one-third of a loaf of corn bread and half a pint of cow
peas for each man, each day. Wood is entirely gone, and occasionally
squads allowed to go and get some under guard. Rowe went
out to-day, was not able to carry much, and that had to be divided
between a hundred men. One of the most annoying things is being
squadded over every few days, sick and all. It’s an all day job,
and have to stand out until we are all tired out, never getting any
food on these days.</p>
<p class="calibre3">June 30.—A new prisoner fainted away on his entrance to Andersonville
and is now crazy, a raving maniac. That is how our
condition affected him. My pants are the worse for wear from
repeated washings, my shirt sleeveless and feet stockingless; have
a red cap without any front piece; shoes by some hocus-pocus are
not mates, one considerable larger than the other. Wonder what
they would think if I should suddenly appear on the streets in
Jackson in this garb. Would be a circus; side show and all. But
nights I have a grand old coverlid to keep off the wet. Raiders
steal blankets and sell to the guards, which leaves all nearly destitute
of that very necessary article. Often tell how I got my coverlid,
to visitors. Have been peddling pea soup on the streets: “Ten<span class="x-ebookmaker-pageno" id="pgepubid00063" title="[74]"><a id="Page_74"></a></span>
cents in money or a dollar Confed for this rich soup! Who takes
it?” And some wretch buys it. Anything in the way of food will
sell, or water, if different from swamp water. Rebs making a
pretense of fixing up sanitary privileges at the swamp, which
amount to nothing. Strong talk of forming a police force to put
down raiders and to enforce order. If successful it will prove of
great benefit. Sanders, Rowe, Blakeman, Dakin and myself are
among those who will take an active part, although the part I take
cannot be very active. Half a dozen letters sent inside to prisoners,
but no news in them that I can hear of. More hot and sultry,
with occasional rains. The crazy man says nothing but “prayer”
will save us. He has been sucking a bone now for about two weeks
and pays more attention to that than to prayer.</p>
<p class="calibre3">July 1.—Matters must approach a crisis pretty soon with the
raiders. It is said that even the rebels are scared and think they
will have no prisoners, should an exchange ever occur. John
Bowen, a Corp. Christency, Hemmingway, Byron Goodsell and
Pete Smith, old acquaintances, have all died within a few days.
Jimmy Devers still lives, with wonderful tenacity to life. To-morrow
he will have been a prisoner of war a year. Mike Hoare still
keeps very well, but the most comical looking genius in the whole
prison. Could make a fortune out of him on exhibition at the
North. He says I look worse however. That may be, but not so
comical. It’s tragedy with the most of us. New guards are taking
the place of the old ones, and it is said that Wirtz is going away.
Hope so. Never have heard one word from Hendryx since his
getting away. Sanders is trying to get outside as a butcher. He
understands the business. “Dad” has been to Australia, and has
told us all about that country. Have also heard all about Ireland
and Scotland. Should judge they were fine countries. Rowe has
been telling me of the advantage of silk under clothing, and in
addition to visiting all the foreign countries, we shall have silk
under wear. Rowe once lived in Boston, and I shall likewise go
there.</p>
<p class="calibre3">July 2.—Almost the Glorious Fourth of July. How shall we
celebrate? Know of no way except to pound on the bake tin,
which I shall do. Have taken to rubbing my limbs, which are
gradually becoming more dropsical. Badly swollen. One of my
teeth came out a few days ago, and all are loose. Mouth very
sore. Battese says: “We get away yet.” Works around and<span class="x-ebookmaker-pageno" id="pgepubid00064" title="[75]"><a id="Page_75"></a></span>
always busy. If any news, he merely listens and don’t say a word.
Even he is in poor health, but never mentions it. An acquaintance
of his says he owns a good farm in Minnesota. Asked him if he
was married—says: “Oh, yes.” Any children? “Oh, yes.” This
is as far as we have got his history. Is very different from Indians
in general. Some of them here are despisable cowards—worse
than the negro. Probably one hundred negroes are here. Not so
tough as the whites. Dead line being fixed up by the rebels. Got
down in some places. Bought a piece of soap, first I have seen in
many months. Swamp now in frightful condition from the filth of
camp. Vermin and raiders have the best of it. Capt. Moseby still
leads the villains.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0009.vue?50bffeb8